namespace Areas.Account.Profile{
    "use strict";

    const baseUrl = "/Account/Profile";
    let webId: number;
    let accountId: number;
    let projectId: number;
    let accountWebId: number;



    export function getWEBId() {
        return webId;
    }

    export function viewLink(cellElement: any, cellInfo: any) {
        buildCellContent(cellElement,
            () => { return cellInfo.data.accountId; },
            "<a href= '/Account/Profile/View/{placeholder}'>View</a>");
    }

    export function onCellPrepared(e: any) {
        if (e.rowType !== "data") {
            return;
        }
        setRowBackground(e);
    }

    function setRowBackground(e: any) {
        accountId = e.component.option("accountId") as number;

        if (e.data.accountId === accountId) {
            e.cellElement.css("background-color", "#FFA07A");

            const rowData: any = e.data;

            const rowForm: any = $("#WebForm").dxForm("instance");
            rowForm.option("formData", rowData);

            const rowProjectForm: any = $("#ProjectForm").dxForm("instance");
            rowProjectForm.option("formData", rowData);

            webId = rowData.accountWebId;

        }
    }

    export function onGridContentReady(e: any) {
        const form = $("#WebForm").dxForm("instance");
        accountId = e.component.option("accountId");
        projectId = e.component.option("projectId")

        $.get(`${baseUrl}/GetAccountWeb/${accountId}`,
            (data) => {
               form.option("formData", data)
            });

        const formProject = $("#ProjectForm").dxForm("instance");

        $.get(`${baseUrl}/GetProjectInfo/${accountId}`,
            (data) => {
                if (data.projectId > 0) {
                    enableButton("SaveProjectInfoButton");
                    formProject.option("disabled", false);
                } else {
                    disableButton("SaveProjectInfoButton");
                    formProject.option("disabled", true);
                }
                formProject.option("formData", data)
            });
    }

    
    export function copyWebsiteProfile() {
        const form = $("#WebForm").dxForm("instance");
        accountId = form.option("KeyId") as number;
        projectId = form.option("ProjectId") as number;
        webId = 0;

        $.get(`${baseUrl}/CopyWebsiteProfile/${accountId}`,
            (data) => { form.option("formData", data) });
    }
    
    export function updateWebsiteProfile() {
        const form = $("#WebForm").dxForm("instance");
        const newData: any = form.option("formData");

        newData.accountId = form.option("KeyId");
        newData.projectId = form.option("ProjectId");

        if (newData.accountWebId == 0) {
            saveRecord(newData);
        } else {
            updateRecord(newData)
        }
    }

    function saveRecord(newData: any) {
        const url = `${baseUrl}/WebsiteProfilePost/${accountId}/${projectId}`;
        const method = "POST";

        sendRequest(url,
            JSON.stringify(newData),
            method);
    }

    function updateRecord(newData: any) {
        accountWebId = newData.accountWebId;
        const url = `${baseUrl}/WebsiteProfilePut/${accountWebId}`;
        const method = "PUT";

        sendRequest(url,
            JSON.stringify(newData),
            method);
    }

    export function createAccount() {
        const parameters = { ProjectId: projectId };
        const createAccountDialog = new Areas.Dialogs.CreateAccountDialog(() => { }, parameters);
   
    }

    export function updateProjectProfile() {
        const form = $("#ProjectForm").dxForm("instance");
        const newData: any = form.option("formData");
        newData.accountId = form.option("KeyId");
        newData.projectId = form.option("ProjectId");

        updateProjectProfileRecord(newData)
    }

    function updateProjectProfileRecord(newData: any) {
        projectId = newData.projectId;
        accountId = newData.accountId;
        const url = `${baseUrl}/ProjectProfilePut/${projectId}/${accountId}`;
        const method = "PUT";

        sendRequest(url,
            JSON.stringify(newData),
            method);
    }


    export function managerLookupItem(itemData: any, itemIndex: any, itemElement: any) {
            itemElement.append(
                `<div><span class="collookupspan">${itemData.displayName}</span>${itemData.primaryEMail}</div>`

            );
    }

    export function initiationContactLookupItem(itemData: any, itemIndex: any, itemElement: any) {
        itemElement.append(
            `<div><span class="collookupspan">${itemData.displayName}</span>${itemData.primaryEMail}</div>`
        );
    }


    export function accountImageUploadDialog() {
        const data = { accountId: accountId };

        const accountProfileImageDialog =
            new Areas.Dialogs.AccountProfileImageDialog(dialogClosing, data);
    }

    function dialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;
        location.href = location.href;
    } 

}
